import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import PreviewImage from '../PreviewImage/PreviewImage'
import classes from './favorite-pose-item.module.sass'
import heartIcon from '../../assets/heart.png'
import Image from "../Image";
import useImageOrientation, { ORIENTATION } from '../../hooks/useImageOrientation';
import cn from 'classnames';
import { IMAGE_ORIENTATION_CACHE } from '../../utils/variables';

const FavoritePoseItem = ({
  actualForeground, foreground2, id, fileName, priorityBg, foreground, backgrounds = [], onFavoriteClick, onImageClick, isSittings, displayBottom = true, favorited, index,
}) => {
  const [bgUrl, setBgUrl] = useState('');

  const checkboxClick = () => {
    onFavoriteClick(id)
  }

  const { orientation } = useImageOrientation(foreground);

  useEffect(() => {
    if (!orientation) return;
    if (backgrounds.length === 0) return;
    if (priorityBg) {
      setBgUrl(priorityBg.imageUrl);
      return;
    }

    const backgroundsForOrientation = backgrounds.filter((bg) => IMAGE_ORIENTATION_CACHE[bg.imageUrl]?.orientation === orientation);

    const background = backgroundsForOrientation[index % backgroundsForOrientation.length];

    setBgUrl(background ? background.imageUrl : backgrounds[0].imageUrl);
    // priorityBg comes from the parent's getAppropriateBg lookup against
    // package_poses, which depends on the usePackagePoses query resolving.
    // On first render that query is still in flight, priorityBg is
    // undefined, this effect runs the round-robin fallback and stores it
    // in bgUrl. When packagePoses arrives the parent re-renders with a
    // populated priorityBg — without it in the deps, this effect doesn't
    // re-run and bgUrl stays stuck on the (wrong) round-robin value.
    // Visible on transparent PNG slots (sport 71/72) because the
    // fallback bg shows through; invisible on JPG slots whose visible
    // image already carries a baked-in background. We track imageUrl
    // (string) instead of the Background object so re-renders that
    // pass a new wrapper around the same background don't flicker.
  }, [backgrounds.length, orientation, priorityBg?.imageUrl]);

  return (
    <div className={cn(classes.poseItem, { [classes.big]: orientation === ORIENTATION.LANDSCAPE })}>
      {!favorited && !isSittings && (
        <div className={classes.checkbox}>
          <input type="checkbox" checked={favorited} onChange={checkboxClick} />
        </div>
      )}

      {favorited && (
        <div className={classes.favorited} onClick={checkboxClick}>
          <Image src={heartIcon} alt="Favorite this image" classes={classes.heartIcon} />
        </div>
      )}

      <div onClick={() => onImageClick(foreground2, foreground)} onMouseDown={() => onImageClick(foreground)}>
        <PreviewImage actualForegroundUrl={actualForeground} foregroundUrl={foreground} backgroundUrl={bgUrl} />
      </div>
    </div>
  )
}

FavoritePoseItem.defaultProps = {
  favoriteDefault: false,
  disabled: false,
  isSittings: false,
}

FavoritePoseItem.propTypes = {
  id: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  foreground: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  onImageClick: PropTypes.func.isRequired,
  onFavoriteClick: PropTypes.func.isRequired,
  favoriteDefault: PropTypes.bool,
  disabled: PropTypes.bool,
  isSittings: PropTypes.bool
}

export default FavoritePoseItem
